"use strict";Object.defineProperty(exports, "__esModule", {value: true});








// Fetch state for the organization step's server-derived invitation and
// domain matches. Phone signups start (and stay) at an empty `ready`.





 const EMPTY_SIGNUP_ORG_MATCHES = {
  status: 'ready',
  matches: { Invites: [], DomainSuggestions: [] },
}; exports.EMPTY_SIGNUP_ORG_MATCHES = EMPTY_SIGNUP_ORG_MATCHES















var SetupSteps; (function (SetupSteps) {
  const PERSONAL_INFO = 1; SetupSteps[SetupSteps["PERSONAL_INFO"] = PERSONAL_INFO] = "PERSONAL_INFO";
  const PHONE_MFA = PERSONAL_INFO + 1; SetupSteps[SetupSteps["PHONE_MFA"] = PHONE_MFA] = "PHONE_MFA";
  const PASSWORD = PHONE_MFA + 1; SetupSteps[SetupSteps["PASSWORD"] = PASSWORD] = "PASSWORD";
  const ORG_INFO = PASSWORD + 1; SetupSteps[SetupSteps["ORG_INFO"] = ORG_INFO] = "ORG_INFO";
  const ORG_SURVEY_REFERRER = ORG_INFO + 1; SetupSteps[SetupSteps["ORG_SURVEY_REFERRER"] = ORG_SURVEY_REFERRER] = "ORG_SURVEY_REFERRER";
  const PRODUCT_INTEREST = ORG_SURVEY_REFERRER + 1; SetupSteps[SetupSteps["PRODUCT_INTEREST"] = PRODUCT_INTEREST] = "PRODUCT_INTEREST";
  const LEGAL_AGREEMENTS = PRODUCT_INTEREST + 1; SetupSteps[SetupSteps["LEGAL_AGREEMENTS"] = LEGAL_AGREEMENTS] = "LEGAL_AGREEMENTS";
  const TRIAL_OFFER = LEGAL_AGREEMENTS + 1; SetupSteps[SetupSteps["TRIAL_OFFER"] = TRIAL_OFFER] = "TRIAL_OFFER";
  const FINISH = TRIAL_OFFER + 1; SetupSteps[SetupSteps["FINISH"] = FINISH] = "FINISH";
})(SetupSteps || (exports.SetupSteps = SetupSteps = {}));

/**
 * Answers collected across the "About your practice" / "Plan & agreements" steps.
 * They live above `OrgSurveySection` (in `useIntermediateValues`) because the
 * section unmounts whenever the user navigates outside the survey range —
 * including back-navigation from the trial offer — and every answer must
 * survive that round trip.
 */


























var WelcomeUserValidStatus; (function (WelcomeUserValidStatus) {
  const COLD = 'Cold'; WelcomeUserValidStatus["COLD"] = COLD;
  const ORG_INVITE = 'Org Invite'; WelcomeUserValidStatus["ORG_INVITE"] = ORG_INVITE;
})(WelcomeUserValidStatus || (exports.WelcomeUserValidStatus = WelcomeUserValidStatus = {}));

var WelcomeUserInvalidStatus; (function (WelcomeUserInvalidStatus) {
  const INVALID_TOKEN = 'Invalid Token'; WelcomeUserInvalidStatus["INVALID_TOKEN"] = INVALID_TOKEN;
  const TOKEN_EXPIRED = 'Token Expired'; WelcomeUserInvalidStatus["TOKEN_EXPIRED"] = TOKEN_EXPIRED;
  const TOKEN_USED = 'Token Used'; WelcomeUserInvalidStatus["TOKEN_USED"] = TOKEN_USED;
  const ACTIVE = 'Active'; WelcomeUserInvalidStatus["ACTIVE"] = ACTIVE;
  const UNVERIFIED_EMAIL = 'Unverified Email'; WelcomeUserInvalidStatus["UNVERIFIED_EMAIL"] = UNVERIFIED_EMAIL;
  const SERVER_ERROR = 'Server Error'; WelcomeUserInvalidStatus["SERVER_ERROR"] = SERVER_ERROR;
})(WelcomeUserInvalidStatus || (exports.WelcomeUserInvalidStatus = WelcomeUserInvalidStatus = {}));












